import { BaseNavigationListItem, BaseNavigationListItemProps } from './BaseNavigationListItem';

type Link = {
  /**
   * Sets the URL that the hyperlink points to. If there is no valid URL do not use NavigationListLinkItem, use other types of NavigationListItem instead.
   */
  href: string;
};
export type NavigationListLinkItemProps<K extends string | number> = Link &
  Pick<
    BaseNavigationListItemProps<K>,
    'label' | 'itemKey' | 'badge' | 'metadata' | 'severity' | 'aria-controls'
  >;
/**
 * NavigationListLinkItem is used to render links in a NavigationList. It allows to view the browser's built in link context menu to open the link in new browser tab.
 */
export function NavigationListLinkItem<K extends string | number>({
  itemKey,
  badge,
  metadata,
  severity,
  href,
  label,
  'aria-controls': ariaControls
}: NavigationListLinkItemProps<K>) {
  return (
    <BaseNavigationListItem
      aria-controls={ariaControls}
      itemKey={itemKey}
      label={label}
      badge={badge}
      metadata={metadata}
      severity={severity}
      href={href}></BaseNavigationListItem>
  );
}
